import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { ShoppingCartFilledIcon } from '@/components/icons'
import { AddOutlinedIcon } from '@/components/icons/AddOutlined'
import { Icon, IconWithLabel, IconWrapper } from '@/components/ui'
import { useCartItemCount } from '@/hooks/features/cart'
import { useCartCount } from '@/stores'

export const CartWithCount = () => {
  const { t } = useTranslation()
  const { cartCount, setCartCount } = useCartCount()

  useCartItemCount({
    config: {
      onSuccess: (data) => {
        if (cartCount.count !== data.count) {
          setCartCount({
            count: data.count,
          })
        }
      },
    },
  })

  return (
    <span className={clsx('tw-relative tw-inline-block', 'tw-pt-2 lg:tw-pt-0')}>
      <IconWithLabel label={t('cart.item.title')} showLabelSp={false}>
        <Icon icon={ShoppingCartFilledIcon} size={'4xl'} color={'primary'} />
      </IconWithLabel>
      <span
        className={clsx(
          'tw-absolute',
          'tw-right-0 tw-top-0 lg:tw--top-2',
          'tw-h-5 tw-w-5 tw-rounded-full',
          'tw-flex tw-items-center tw-justify-center',
          'tw-bg-accentYellow-500',
          'tw-text-2xs tw-font-bold tw-text-primary-500'
        )}
      >
        {cartCount.count < 100 ? cartCount.count : 99}
      </span>
      <span className="tw-sr-only">{t('cart.item.count')}</span>
      {cartCount.count >= 100 && (
        <span
          className={clsx(
            'tw-absolute tw--right-0.5 tw-top-0',
            'tw-flex tw-items-start tw-justify-end'
          )}
        >
          <IconWrapper>
            <Icon icon={AddOutlinedIcon} size={'xs'} color={'primary'} />
          </IconWrapper>
        </span>
      )}
    </span>
  )
}
